import DeleteMerchantModal from './delete-merchant-modal';

export default DeleteMerchantModal;
